import { createContext } from '@shared/utils/createContext';
import type { EventPersonContextValue } from './EventPerson.types';

// Shared createContext helper so missing-provider crashes are reported to New Relic.
const [EventPersonContextProvider, useEventPerson] = createContext<EventPersonContextValue>({
  name: 'EventPersonProvider',
});

export { EventPersonContextProvider, useEventPerson };
